
import React ,{useState,useEffect} from  'react';
import {Bar} from 'react-chartjs-2';
import zoom from '../../assets/icons/zoom.svg';
import { APIEndpoint } from '../../utils/axios';
import VerticalDivider from '../../assets/icons/svg/vertical-divider.svg';
import { durationFilterSelect} from '../../utils/configs';
import { Loading } from '../../common';
import {downloadFileDashboard} from '../../utils/commonFunctions';
import DownloadVector from '../../assets/icons/svg/download-vector.svg';
import { CiCalendarDate } from "react-icons/ci";
import {
  Chart, CategoryScale, LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend} from 'chart.js';

Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

  export const options_flights = {
    plugins: {
      title: {
        display: false,
        text: 'Total Flights',
      },
      legend: {
        display: false
    },
    },
    responsive: true,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          color: '#ffffff1f'
           }
      },
      y: {
        stacked: true,
        grid: {
          color: '#ffffff1f'
           }
      },
    },
  };

export const BarCharts = ( { chartLabel,isLoading,setLoadingWidgets, data,options,filtersBar, customDateLabel, setCustomDateLabel, filtersChartZoom,setFilteredWidgetData,handleZoom,setFiltersChartZoom,chartZoom,setShowDateModal,setWidgetRangeId })=> {

  const [filters,setFilters]=useState("thisWeek");
  const [responseChart,setResponseChart]=useState({});
  const [,setDateRangeFilters]=useState({});
  const [chartHeight, setChartHeight] = useState(230);

  const currentFilter = !chartZoom ? filters : filtersChartZoom;
  const isBetweenDates = currentFilter === "betweenDates";

  useEffect(() => {
    if (chartZoom) {
      setChartHeight(400);
    } else {
      setChartHeight(230);
    }
  }, [chartZoom]);

  useEffect( () => {
    setFilters(filtersBar?.sortBy);
    if(filtersBar && (Object.keys(filtersBar).includes('appliedFilters')||Object.keys(filtersBar).includes('startDate'))){
        filtersBar.appliedFilters? setDateRangeFilters(filtersBar.appliedFilters):setDateRangeFilters(filtersBar)
    }
  }, [filtersBar]);

  const changeFilter = async (e) => {
    e.preventDefault();
    const value = e.target.value;
    const wId = data.widgetId;
    if(value !== 'betweenDates'){
         setCustomDateLabel(prev=>({...prev,[wId]:""}))
      }

    if (value === "betweenDates") {
      setShowDateModal(true);
      setWidgetRangeId(wId);
      return;
  	}
  
    setFilters(value)
    setFiltersChartZoom(value);
    setLoadingWidgets((_)=>({..._,[wId]:true}));
    if(!chartZoom){
      try {
        const resp = await APIEndpoint.get(`portal/v1/widget/${wId}?sortBy=${value}`);
        if(resp.success){
          setFilteredWidgetData(resp.data);
        }
      }
      catch (error) {
        console.log(error);
      }finally{
      setLoadingWidgets((_)=>({..._,[wId]:false}));
      }
    }else{
      try {
        const resp = await APIEndpoint.get(`portal/v1/widget/${wId}?sortBy=${value}`);
        if(resp.success){
          setResponseChart(resp.data);
        }
      }
      catch (error) {
        console.log(error);
      }finally{
        setLoadingWidgets((_)=>({..._,[wId]:false}));
      }
    }
  };

  const setView=()=>{
    if(filters){
      setFiltersChartZoom(filters)
      handleZoom(chartLabel,data,options)
    }
  }

  const onBtExport=()=>{
    if(Object.keys(responseChart).length > 0){
      downloadFileDashboard(responseChart)
    }else{
      downloadFileDashboard(data,responseChart)
    }
  }

  const isDatasetsHaveValidData = (datasets) => {
    if (!datasets || datasets.length === 0) {
      return true; // No datasets available
    }

    return datasets.every((dataset) => {
      if (!dataset.data || dataset.data.length === 0) {
        return true; // No data in this dataset
      }

      return dataset.data.every((value) => value === 0); // Check if all values are zero
    });
  };

  return (
      <>
      <div className='w-100 flexRow alignItemsCenter' key={data.widgetId}>
      <div className='w-100 flexRow alignItemsCenter mt-3 justifyContentSpaceBetween'>
        <div  className='mb-2 component-header-space'>{data.title}</div>
          <div className="flexRow alignItemsCenter jusitifyContentSpaceEvenly">
            <img className="icon-charts" src={DownloadVector} alt="Download icon" onClick={onBtExport}/>
            <img className="icon-divider-charts" src={VerticalDivider} alt="|" />
            <span className='flexRow justifyContentSpaceBetween'>
             {isBetweenDates && <span
                                  onClick={() => {
                                  setShowDateModal(true);
                                  setWidgetRangeId(data.widgetId);
                                  }}
                                  title="Edit date range"
                                 >
                              <CiCalendarDate size={20}  color={'#e8812eff'} style={{cursor:'pointer'}} />
                                &nbsp;&nbsp;
                              </span> }
              <button className='dashboard-border select-dashboard-border'>
                <select
                className='dashboard-button-report'
                title ={(isBetweenDates && customDateLabel) ? customDateLabel :""}
                onChange={changeFilter} value={!chartZoom?filters:filtersChartZoom}>
                  {durationFilterSelect.map((item, index) => {
                  let label = item.label;

                  if (item.value === "betweenDates" && customDateLabel) {
                  label = customDateLabel;  
                  }
                  return (
                  <option key={index} value={item.value}>
                  {label}
                  </option>
                  );
                  })}
                </select>
              </button>
            </span>
          </div>
      </div>
    </div>
  <div style={{ position: "relative" }} className="card-content2">

  {isLoading ? (
    <div
      className='flexRow justifyContentCenter alignItemsCenter'
      style={{
        height: `${chartHeight}px`,
      }}
    >
     <Loading/>
    </div>
  ) : (
    <>
      {
        data?.datasets && !Boolean(Object.keys(responseChart).length) ? (
          (!isDatasetsHaveValidData(data?.datasets)) ? (
            <div style={{ minHeight: `${chartHeight}px`, height: `${chartHeight}px`, position: 'relative', width: '100%' }}>
              <Bar
                datasetIdKey={data.widgetId}
                data={data}
                options={{ ...options, plugins: { ...options.plugins, datalabels: { display: false } } }}
              />
            </div>
          ) : (
            <div className='flexRow justifyContentCenter alignItemsCenter dashboard-message'>
              <p>No data available</p>
            </div>
          )
        ) : (
          (!isDatasetsHaveValidData(responseChart?.datasets)) ? (
            <div style={{ minHeight: `${chartHeight}px`, height: `${chartHeight}px`, position: 'relative', width: '100%' }}>
              <Bar
                datasetIdKey={responseChart.widgetId}
                data={responseChart}
                options={{ ...options, plugins: { ...options.plugins, datalabels: { display: false } } }}
              />
            </div>
          ) : (
            <div className='flexRow justifyContentCenter alignItemsCenter dashboard-message'>
              <p>No data available</p>
            </div>
          )
        )
      }
    </>
  )}

</div>

    <div className="container-fluid sm-scrollbar mt-4">
    { !isDatasetsHaveValidData(data?.datasets) && (
        <div className=" flexRow justifyContentSpaceEvenly">
          {!Boolean(Object.keys(responseChart).length)?data.datasets.map((item,index) => {
            return (
              <div className={`${!chartZoom ? 'chart-label-bar-chart col-lg-3' : 'zoom-container'}`} key={index}>
                <ul className={`${index === 0 || 'chart-label-seperator'}`}>
                  <li className='dashboard-bullet-bar' style={{color:item.backgroundColor}} >
                    <div className="chart-heading-pie" style={{paddingLeft:'4px'}}>{item.label}</div>
                  </li>
                </ul>
              </div>
            )
          }):!isDatasetsHaveValidData(responseChart?.datasets) && responseChart?.datasets.map((item,index) => {
                return (
                  <div className={`${!chartZoom ? 'chart-label-bar-chart col-lg-3' : 'zoom-container'}`} key={index}>
                    <ul className={`${index === 0 || 'chart-label-seperator'}`}>
                      <li className='dashboard-bullet-bar' style={{color:item.backgroundColor}} >
                        <div className="chart-heading-pie" style={{paddingLeft:'4px'}}>{item.label}</div>
                      </li>
                    </ul>
                  </div>
                )
              })}
           <span className="icon-enlarge" style={{marginTop:'1rem'}}>
             {!chartZoom && <img alt='zoom' src={zoom} onClick={()=>setView()} />}
          </span>
        </div>
    )}
        </div>
    </>
    )
}
